import { MRT_Row } from '@talentmesh/table';
import { SmallBadge } from '@talentmesh/ui/components/badge';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';
import UIStrings from '@/Utils/UIStrings';

interface CandidateRowEntryInternalBenchmarkBadgeProps {
    row: MRT_Row<CandidateRowEntry>;
}

const CandidateRowEntryInternalBenchmarkBadge = ({ row }: CandidateRowEntryInternalBenchmarkBadgeProps) => {
    const candidate = row.original;

    if (!candidate.isInternal) {
        return undefined;
    }

    return (
        candidate.isInternal && (
            <SmallBadge variant="default" className="text-center">
                {UIStrings.InternalBenchmark}
            </SmallBadge>
        )
    );
};

export default CandidateRowEntryInternalBenchmarkBadge;
